import { Calendar } from '@creditornot/cb-icons';
import { Input } from '@creditornot/cb-input';
import { LegacyPopover } from '@creditornot/cb-popover';
import { DateTime } from 'luxon';
import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { FilterDateRangePicker } from './FilterDateRangePicker';
import { useCampaignModuleContext } from '../../context';
import { DateRange } from '../../types';

const DateRangePickerInput = styled(Input)`
  min-width: 230px;
`;

type CampaignAnalyticsDateRageFilterProps = {
  onUpdate: (value: DateRange) => void;
  dateRange: DateRange;
};

const dateToString = (date: DateTime | undefined, locale: string) =>
  date?.toLocaleString(DateTime.DATE_SHORT, {
    locale,
  }) ?? '';

const dateRangeToString = (dateRange: DateRange, locale: string) =>
  `${dateToString(dateRange?.from, locale)} - ${dateToString(dateRange?.to, locale)}`;

export const CampaignAnalyticsDateRageFilter = ({ onUpdate, dateRange }: CampaignAnalyticsDateRageFilterProps) => {
  const intl = useIntl();
  const { timezone } = useCampaignModuleContext();

  return (
    <LegacyPopover
      content={
        <FilterDateRangePicker
          onDateRangeChange={period => {
            onUpdate(period);
          }}
          placeholder={'Select date range'}
          value={dateRange}
          timezone={timezone}
        />
      }
      showOnClick
      showOnHover={false}
      renderArrow={false}
      placement="bottom"
      disableContentPadding
    >
      <DateRangePickerInput value={dateRangeToString(dateRange, intl.locale)} icon={<Calendar />} readOnly />
    </LegacyPopover>
  );
};
